import { useCallback, useMemo, useState } from 'react';

type ModelOverrideScope = 'agent' | 'all';

export type UseModelSelectionResponse = {
  model: string | null;
  scope: ModelOverrideScope;
  setModel: (model: string | null) => void;
  setScope: (scope: ModelOverrideScope) => void;
  clear: () => void;
  getModel: () => string | null;
  getScope: () => ModelOverrideScope;
};

export const useModelSelection = (): UseModelSelectionResponse => {
  const [model, setModel] = useState<string | null>(null);
  const [scope, setScope] = useState<ModelOverrideScope>('agent');

  const clear = useCallback(() => {
    setModel(null);
    setScope('agent');
  }, []);

  const getModel = useCallback(() => {
    return model;
  }, [model]);

  const getScope = useCallback(() => {
    return scope;
  }, [scope]);

  return useMemo(
    () => ({
      model,
      scope,
      setModel,
      setScope,
      clear,
      getModel,
      getScope,
    }),
    [model, scope, clear, getModel, getScope],
  );
};
